import React, { useEffect, useMemo } from 'react';
import CustomSelect from '../../components/CustomSelect';
import {
  useGetCustomSelectButtonElement,
  useSetSelectDefaultValue,
} from '../../hooks/init';
import type { PlatformType } from '../../types';
import { platformPlaceholder } from '../../constants/placeholder';
import { commonBackInfo } from '../../utils';
import { useIntl } from 'umi';
import { FilterButtonPoint } from '@op/operationLog/pages/filter';

export default function PlatformSelect({
  onChange,
  defaultValue,
  defaultKey,
  filterValue,
  filterOptions,
  lang,
}: PlatformType) {
  const options = useMemo(() => {
    if (!filterOptions) {
      return [];
    }
    return filterOptions.map?.((item: any) =>
      typeof item === 'string' ? { text: item, value: item } : item,
    );
  }, [filterOptions]);

  const { customSelectRef, getButtonElement } =
    useGetCustomSelectButtonElement();

  const { formatMessage } = useIntl();

  const {
    diffClassName,
    selects: platformSelects,
    setSelects: setPlatformSelects,
  } = useSetSelectDefaultValue<string>({
    defaultValue,
    filterValue,
    defaultKey: 'platform',
    options: options?.map((item: any) => item.value),
  });

  useEffect(() => {
    const [text, isAll] = getButtonElement();
    onChange?.(
      'platform',
      commonBackInfo(
        { platform: platformSelects },
        { [defaultKey]: text },
        { needChangeEntity: true, isAll },
      ),
    );
  }, [platformSelects, formatMessage]);

  return (
    <div className={`platform-select-wrapper ${diffClassName}`}>
      <CustomSelect
        ref={customSelectRef}
        placeholderText={platformPlaceholder[lang]}
        onClear={() => setPlatformSelects([])}
        selectOptionsInfo={[platformSelects, setPlatformSelects]}
        options={options}
        pointKey={FilterButtonPoint.platform}
      ></CustomSelect>
    </div>
  );
}
